export default __webpack_public_path__ + "static/media/python.ab5b883c.svg";